// Card editor character limits
export const CARD_LIMITS = {
  MAX_FRONT_LENGTH: 500,
  MAX_BACK_LENGTH: 1000,
} as const;

// Helper function to get plain text length from HTML content
export const getTextLength = (htmlContent: string): number => {
  return htmlContent.replace(/<[^>]*>/g, '').length;
};

// Helper function to check if content exceeds limit
export const isContentTooLong = (htmlContent: string, maxLength: number): boolean => {
  return getTextLength(htmlContent) > maxLength;
};

// Helper function to get character count status for styling
export const getCharCountStatus = (count: number, maxLength: number) => {
  if (count > maxLength) {
    return 'error';
  } else if (count > maxLength * 0.8) {
    return 'warning';
  }
  return 'normal';
};

// Helper function to validate card content
export const validateCardContent = (front: string, back: string) => {
  const errors: string[] = [];
  
  // Check for empty content
  const frontIsEmpty = !front || 
                      front.trim() === '' || 
                      front.replace(/<[^>]*>/g, '').trim() === '';
  const backIsEmpty = !back || 
                     back.trim() === '' || 
                     back.replace(/<[^>]*>/g, '').trim() === '';
  
  if (frontIsEmpty || backIsEmpty) {
    errors.push('Os campos de pergunta e resposta são obrigatórios');
  }
  
  // Check character limits
  const frontLength = getTextLength(front);
  const backLength = getTextLength(back);
  
  if (frontLength > CARD_LIMITS.MAX_FRONT_LENGTH) {
    errors.push(`Pergunta excede ${CARD_LIMITS.MAX_FRONT_LENGTH} caracteres (${frontLength}). Por favor, reduza o texto.`);
  }
  
  if (backLength > CARD_LIMITS.MAX_BACK_LENGTH) {
    errors.push(`Resposta excede ${CARD_LIMITS.MAX_BACK_LENGTH} caracteres (${backLength}). Por favor, reduza o texto.`);
  }
  
  return {
    isValid: errors.length === 0,
    errors,
    frontLength,
    backLength
  };
};